import http from '../http';

/**
 * @namespace 角色权限模块
 */

export const getInquiryList = (
  importance?: string,
  status?: string,
  search?: string,
  companyId?: number | string,
  isAdminInquiry?: boolean
) => {
  return http.get(`inquiries`, {
    params: { importance, status, search, companyId, isAdminInquiry }
  });
};

export const createInquiry = (body: FormData) => {
  return http.post(`inquiries`, body);
};

export const getInquiryDetails = (id: number) => {
  return http.get(`inquiries/${id}`);
};

export const replyInquiry = (id: number, body: FormData) => {
  return http.post(`inquiries/${id}/replies`, body);
};

export const updateInquiryStatus = (id: number, status: string) => {
  return http.put(`inquiries/${id}/statuses?status=${status}`);
};

export const deleteInquiry = (id: number) => {
  return http.delete(`inquiries/${id}`);
};
